import useApiClient from './api-client'
import type { CategoryDetailData } from '@/types/api'

export const getCategory = async (categoryId: number | string, regionId: number | string) => {
  const api = useApiClient<CategoryDetailData>()
  const result = await api(`/category/${categoryId}`, {
    query: {
      region_id: regionId,
    },
  })

  return result
}
